import { render, staticRenderFns } from "./PosterTips.vue?vue&type=template&id=d539e182&"
import script from "./PosterTips.vue?vue&type=script&lang=ts&"
export * from "./PosterTips.vue?vue&type=script&lang=ts&"
import style0 from "./PosterTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports